(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rating-stars"] && !Shopify.designMode) return;
  try {
    (function () {
    // Cible la section avis Yotpo (wrapper du bloc app, ou widget principal).
    function findReviews() {
      return (
        document.getElementById('product-reviews') ||
        document.querySelector('[id*="yotpo_product_reviews"]') ||
        document.getElementById('yotpo-reviews-main-widget') ||
        document.querySelector('.yotpo-widget-instance')
      );
    }
    // Décalage pour ne pas passer sous le header sticky.
    function headerOffset() {
      var h = document.querySelector('header-component, .header, .section-header');
      return (h ? h.getBoundingClientRect().height : 70) + 14;
    }
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href$="#product-reviews"]');
      if (!link) return;
      var target = findReviews();
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
